var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Contacts'),_c('ContactsSuccess'),_c('ContactsError')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }